// Auto-generated by scripts/generate-version.js — do not edit
export const BUILD_HASH = "e07612e9acbf";
export const BUILD_VERSION_NUMBER = 28;
